import { Spin } from 'antd'
import InputMask from '@mona-health/react-input-mask'

import type { IInput, InputSizeType } from "./types"
import css from "./index.module.scss"


/** Компонент Input */
export const Input = ({
    id,
    name,
    type = 'text',
    placeholder,
    autoComplete = 'off',

    prefix,
    suffix,

    width,
    maxWidth,
    minWidth,
    paddingLeft,
    paddingRight = '5px',

    fontSize,
    size = 'md',
    variant = 'primary',
    textAlign = 'left',
    maxLength,
    mask,
    maskChar,

    isLoading = false,
    isDisabled = false,
    isReadOnly = false,
    isVisible = true,
    isRendered = true,

    value,
    onChange,
    onBlur,
}: IInput) => {
    /** Стили компоненты */
    const componentStyle: React.CSSProperties = {
        display: isVisible ? 'flex' : 'none',
        width: width,
        maxWidth: maxWidth, 
        minWidth, 
        paddingRight: paddingRight, 
        paddingLeft: paddingLeft,
        fontSize: fontSize,
    }

    /** Стили input */
    const inputStyle: React.CSSProperties = {
        textAlign: textAlign
    }

    const getSizeClassName = (size?: InputSizeType) => {
        switch (size) {
            case 'lg': return css.lg
            case 'md': return css.md
            case 'sm': return css.sm
            case 'xs': return css.xs
            default: return css.md
        }
    }

    const inputType = (type: React.HTMLInputTypeAttribute | 'mask') => {
        switch (type) {
            case 'mask': return (
                <InputMask 
                    id={id} 
                    name={name}
                    mask={mask || ''}
                    maskChar={maskChar} 
                    placeholder={placeholder} 
                    value={value}
                    onChange={onChange} 
                    onBlur={onBlur}
                    autoComplete={autoComplete} 
                    readOnly={isReadOnly} 
                    disabled={isDisabled} 
                    className={`${getSizeClassName(size)}`} 
                />
            )

            default: return (
                <input
                    id={id}
                    name={name}
                    type={type}
                    maxLength={maxLength}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    readOnly={isReadOnly}
                    disabled={isDisabled}
                    className={`${getSizeClassName(size)}`}
                    style={inputStyle}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                />
            )
        }
    }

    return <>
        {isRendered && <div className={`${css[variant]} ${getSizeClassName(size)} ${isDisabled && css['disabled']}`} style={componentStyle} onClick={(e) => e.stopPropagation()}>
            {prefix}
            {inputType(type)}
            {suffix}

            {isLoading && <div className={css.isLoading}><Spin size='small' styles={{ indicator: { color: 'var(--color_txt_accent)' } }} /></div>}
        </div>}
    </>
}